'use client';

import { usePathname, useRouter } from 'next/navigation';
import React, { useState, useRef, useEffect } from 'react';

import {
  LOCALIZATIONS_ARRAY,
  DEFAULT_LOCALE,
  type LOCALIZATIONS,
} from '@/utils/type/localizations';

// const LABELS: Record<LOCALIZATIONS, string> = {
//   uk: 'UA',
//   en: 'EN',
//   pl: 'PL',
// };

const LABELS: Record<LOCALIZATIONS, string> = {
  uk: 'UA',
  en: 'EN',
  pl: 'PL',
};

export default function LocaleSwitcher() {
  const router = useRouter();
  const pathname = usePathname();
  const [open, setOpen] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  const currentLocale = (() => {
    const firstSegment = pathname?.split('/')?.[1];
    return LOCALIZATIONS_ARRAY.includes(firstSegment as LOCALIZATIONS)
      ? (firstSegment as LOCALIZATIONS)
      : DEFAULT_LOCALE;
  })();

  useEffect(() => {
    function onClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  function onSelectLocale(newLocale: LOCALIZATIONS) {
    if (newLocale === currentLocale) {
      setOpen(false);
      return;
    }

    const segments = pathname?.split('/').filter(Boolean) || [];

    // Видаляємо поточний префікс локалі, якщо він є
    if (LOCALIZATIONS_ARRAY.includes(segments[0] as LOCALIZATIONS)) {
      segments.shift();
    }

    // Для української мови (дефолтної) не додаємо префікс
    let newPath: string;
    if (newLocale === DEFAULT_LOCALE) {
      newPath = '/' + segments.join('/');
    } else {
      newPath = '/' + newLocale + (segments.length > 0 ? '/' + segments.join('/') : '');
    }

    setOpen(false);
    router.push(newPath);
  }

  return (
    <div ref={ref} className="relative inline-block text-left select-none">
      <button
        onClick={() => setOpen(v => !v)}
        className="bg-black text-white px-3 py-1 rounded-md font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500 border border-white flex items-center"
        aria-haspopup="true"
        aria-expanded={open}
        aria-label="Вибір мови"
        type="button"
      >
        <span className="pt-1">{LABELS[currentLocale]}</span>
      </button>

      {open && (
        <ul className="absolute right-0 mt-1 w-20 bg-black rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
          {LOCALIZATIONS_ARRAY.map(loc => (
            <li key={loc}>
              <button
                type="button"
                className={`w-full text-left px-3 py-2 text-white hover:bg-gray-800 focus:bg-gray-700 ${
                  loc === currentLocale ? 'font-bold' : ''
                }`}
                onClick={() => onSelectLocale(loc)}
              >
                {LABELS[loc]}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
